import { useFeatureParticipationRecorder, useFeatureTernary } from "@viagogo/feature";
import { FeatureSetEnum } from "src/shared/constants/FeatureSetEnum";

export const useDedupedCarousels = ({
  model,
  showComedy,
  recentlyViewedItems,
  showAddRecentlyViewedToModel,
  showRecommendedForYou,
}) => {
  "use no memo";
  const dedupeCategoryCarousels = useFeatureTernary(FeatureSetEnum.TMHomeNoDedupeRecentViewedRfyTlc);
  const dedupeCategoryCarouselsEnabled = dedupeCategoryCarousels({
    record: false,
    control: () => true,
    variant: () => false,
  });
  const recordTMHomeNoDedupeRecentViewedRfyTlcParticipation = useFeatureParticipationRecorder(
    FeatureSetEnum.TMHomeNoDedupeRecentViewedRfyTlc,
    () => true,
  );
  let dedupeCategoryIds = [];
  if (recentlyViewedItems?.items?.length && (showRecommendedForYou || showAddRecentlyViewedToModel)) {
    recordTMHomeNoDedupeRecentViewedRfyTlcParticipation();
    if (dedupeCategoryCarouselsEnabled) {
      let recForYouCatIds = new Set();
      const items = model.recommendationCategories?.categoryItems?.items;
      if (items?.length) {
        recForYouCatIds = new Set(items.map((item) => item.categoryId));
      }

      // Deduplicate recently viewed items only if RecForYou set has items in it
      if (recForYouCatIds.size > 0) {
        recentlyViewedItems.items = recentlyViewedItems.items.filter((item) => !recForYouCatIds.has(item.categoryId));
      }

      // Add all items from recentlyViewedItems and recommendationCategories to dedupeCategoryIds
      dedupeCategoryIds = [...recentlyViewedItems.items.map((item) => item.categoryId), ...recForYouCatIds];

      if (showComedy && dedupeCategoryIds.length > 0) {
        // Need to filter away dedupeCategoryIds categories for initial comedy load, since it's not being lazy-loaded
        model.comedy.categoryItems.items = model.comedy.categoryItems.items.filter(
          (item) => !dedupeCategoryIds.includes(item.categoryId),
        );
      }
    }
  }

  return dedupeCategoryIds;
};
